export const _id = [...Array(40)].map(
  (_, index) => `e99f09a7-dd88-49d5-b1c8-1daf80c2d7b${index + 1}`
);

// ----------------------------------------------------------------------
export const _departments_faculty_name = [
  // 'York Hospital',
  // 'Ambulatory Clinic',
  // 'Gettysburg Hospital',
  'WellSpan Behavioral Health',
  'WellSpan Medical Oncology & Hematology',
  'WellSpan Cardiology',
  'WellSpan Dermatology',
  'WellSpan Endocrinology',
  'WellSpan Digestive Health',
  'WellSpan Infectious Disease Specialists',
  'WellSpan Internal Medicine - Waynesboro',
  'WellSpan Internal Medicine - Washington Street',
  'WellSpan OB/GYN - Washington St.',
  'WellSpan Pediatric Medicine - Joppa Road',
  'WellSpan Pulmonary & Sleep Medicine',
  'WellSpan Rheumatology',
  'Apple Hill Surgical Center',
  'WellSpan Urology',
  'WellSpan Vascular Surgery',
];
// ----------------------------------------------------------------------
export const _departments_location = [
  // '123 Main Street York PA 20967',
  // '124 Main Street York PA 20967',
  // '2387 Lane Drive Gettysburg PA 21088',
  '176 S. Coldbrook Ave. Chambersburg, PA 17201',
  '601 E. Main St. Waynesboro, PA 17268',
  '1227 Baltimore St. Hanover, PA 17331',
  '292 St. Charles Way York, PA 17403',
  '24 Antrim Commons Dr. Greencastle, PA 17225',
  '501 E. Main St. Waynesboro, PA 17268',
  '175 Martin Ave. Ephrata, PA 17522',
  '601 E Main St. Waynesboro, PA 17268',
  '423 S Washington St. Gettysburg, PA 17325',
  '450 S. Washington St. Gettysburg, PA 17325',
  '2675 Joppa Rd. York, PA 17403',
  '601 E Main St. Waynesboro, PA 17268',
  '292 St. Charles Way York, PA 17403',
  '25 Monument Rd. York, PA 17403',
  '24 Antrim Commons Dr. Greencastle, PA 17225',
  '1227 Baltimore St. Hanover, PA 17331',
];
// ----------------------------------------------------------------------
export const _departments_department = [
  // 'Cardiology Clinic',
  // 'Cardiology Clinic',
  // 'Endocrinology',
  // 'OBGYN',
  'Behavioral Health',
  'Cancer Care',
  'Cardiovascular',
  'Dermatology',
  'Endocrinology',
  'Gastroenterology',
  'Infectious Disease',
  'Int Medicine - Waynesbro',
  'Int Medicine - Washington',
  'Obstetrics/Gynecology',
  'Pediatric Medicine',
  'Pulmonary',
  'Rheumatology',
  'Surgical Centers',
  'Urology',
  'Vascular Surgery',
];
// ----------------------------------------------------------------------
export const _departments_cost_center = [
  // 'DTC-0293', 'DTC-0295', 'DTC-2700', 'DTC-4293',
  'BH-0021',
  'CAN-0014',
  'CAR-0011',
  'DRM-0019',
  'END-0033',
  'GAS-0007',
  'INF-0008',
  'INM-0011',
  'INM-0012',
  'OBG-0002',
  'PED-0001',
  'PUL-0004',
  'RHM-0007',
  'SUR-0021',
  'URO-0003',
  'VAS-0002',
];
// ----------------------------------------------------------------------
export const _departments_faculty = [
  // 'Ambulatory Clinic',
  // 'Gettysburg Hospital',
  // 'York Hospital',
  // 'Ambulatory Clinic',
  'WellSpan Behavioral Health',
  'WellSpan Medical Oncology & Hematology',
  'WellSpan Cardiology',
  'WellSpan Dermatology',
  'WellSpan Endocrinology',
  'WellSpan Digestive Health',
  'WellSpan Infectious Disease Specialists',
  'WellSpan Internal Medicine - Waynesboro',
  'WellSpan Internal Medicine - Washington Street',
  'WellSpan OB/GYN - Washington St.',
  'WellSpan Pediatric Medicine - Joppa Road',
  'WellSpan Pulmonary & Sleep Medicine',
  'WellSpan Rheumatology',
  'Apple Hill Surgical Center',
  'WellSpan Urology',
  'WellSpan Vascular Surgery',
];

// App Details
// ----------------------------------------------------------------------
export const _app_details_name = [
  // 'Allscripts', 'Cerner', 'NextGen', 'GEMMS',
  'Allscripts - Pro (Ephrata)',
  'Allscripts - Pro (Gettysburg)',
  'Allscripts - Touchworks',
  'AthenaHealth EHR- Ephrata',
  'AthenaHealth EHR- York',
  'Cerner (Ephrata)',
  'Cerner-1 (Main)',
  'DrChrono',
  'EClinicalWorks - 1',
  'EClinicalWorks - 2',
  'GEMMS',
  'NextGen - 2',
  'NextGen -1',
  'Practice Fusion',
  'Prime Suite',
];
// ----------------------------------------------------------------------
export const _app_details_department = [
  // 'Entity', 'Entity', 'Dermatology', 'Cardiology',
  'WellSpan Internal Medicine - Waynesboro',
  'WellSpan OB/GYN - Washington St.',
  'Entity',
  'Entity',
  'Entity',
  'Entity',
  'Entity',
  'WellSpan OB/GYN - Washington St.',
  'Entity',
  'WellSpan Pediatric Medicine - Joppa Road',
  'WellSpan Cardiology',
  'WellSpan Dermatology',
  'WellSpan Dermatology',
  'Apple Hill Surgical Center',
  'WellSpan Digestive Health',
];
// ----------------------------------------------------------------------
export const _app_details_vendor = [
  // 'Veradigm Inc',
  // 'Oracle Inc',
  // 'NextGen Health Information',
  // 'Reseller- Carasoft',
  'Veradigm Inc',
  'Veradigm Inc',
  'Veradigm Inc',
  'AthenaHealth EHRE',
  'AthenaHealth EHRE',
  'Oracle Inc',
  'Oracle Inc',
  'DrChrono',
  'EClinicalWorks',
  'EClinicalWorks',
  'Reseller- Carasoft',
  'NextGen Health Information',
  'NextGen Health Information',
  'Practice Fusion',
  'Greenway Health',
];
// ----------------------------------------------------------------------
export const _app_costs_category = [
  'License',
  'Annual Maintenance',
  'Infrastructure',
  'Staff',
  'Hosting/On-prem',
  'Server Upgrades',
  'Help Desk Support',
  'Other',
];
// ----------------------------------------------------------------------
export const _app_costs_cost = [1349000, 600000, 800000, 12000000, 250000, 0, 0, 0];
// ----------------------------------------------------------------------
export const _app_costs_type = ['CapEx', 'OpEx', 'CapEx', 'OpEx', 'OpEx', 'CapEx', 'OpEx'];
// ----------------------------------------------------------------------
export const _projects_name = [
  'Impravata',
  'Firewall Upgrade',
  'Keytronics',
  'HIM Integrations',
  'Handhelds',
];
// ----------------------------------------------------------------------
export const _projects_contact_name = [
  'Ethan Hunt',
  'Steve Promethius',
  'Robin Hood',
  'Kevin Mitnick',
  'Edward Scissor',
];
// ----------------------------------------------------------------------
export const _projects_email = [
  'Hunt.Ethan@imprivata.com',
  'SteveP@sophos.com',
  'RHood@keytronic.net',
  'zerocool@netscape.net',
  'ewscissor@panasonic.com',
];
// ----------------------------------------------------------------------
export const _projects_phone = [
  '573-555-0000',
  '555-555-5533',
  '555-555-5512',
  '555-555-1231',
  '555-555-2394',
];
